import { AuthRoles } from '../../models/enums/enums';
import { PersonalInfoState } from '../../models/enums/peronsalInfoState';

export class UpdateUser {
  static readonly type = '[User] Update';
  constructor(public payload: {
    id:string,
    email:string,
    phoneNumber?:string,
    firstName:string,
    lastName?:string,
    role?:AuthRoles[],
    isNewUser:boolean,
    profileImageUrl?: string,
    personalInfoState?: PersonalInfoState,
    profileImageFormat?: string,
    degreePreference?: number }) {}
}

export class UpdateProfileCoverImage{
  static readonly type = '[User] Update Photos';
  constructor(public payload: {
    profileImageUrl?: string,
    profileImageUrlFormat?: string
  }){}
}

export class SkipTour{
  static readonly type = '[User] Skip Tour';
  constructor(public payload:{
    isNewUser: boolean
  }){}
}
